// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vLXh","right":"styles_right__3iPUW"};